import React from "react"

const HorizontalRule = () => {
  return <hr className="mx-6 my-4 bg-gray-300" />
}

export default HorizontalRule
